import InfoCard from "./InfoCard";

const Introduction = () => {
  return (
    <div className="p-6 md:p-12 max-w-[90%] mx-auto">
      {/* Title Section */}
      <h1 className="text-2xl md:text-4xl font-bold text-center mb-4 text-tertiary">
        जन शिक्षण संस्थान, बीकानेर
      </h1>
      <p className="text-center text-lg md:text-xl text-tertiary mb-4">
        कौशल विकास एवं उद्यमिता मंत्रालय, भारत सरकार द्वारा वित्त पोषित
      </p>

      {/* Main Content */}
      <div className="space-y-6 text-tertiary">
        <InfoCard title="परिचय:">
          जन शिक्षण संस्थान, बीकानेर भारत सरकार के कौशल विकास एवं उद्यमिता मंत्रालय
          के सौजन्य से बीकानेर प्रौढ़ शिक्षण समीती, बीकानेर द्वारा संचालित किया जा
          रहा है। जन शिक्षण संस्थान, बीकानेर की स्थापना सन् 2000 में हुई।
          उल्लेखनीय है कि जन शिक्षण संस्थान स्कीम की शुरूआत राष्ट्रीय साक्षरता
          मिशन, स्कूल शिक्षा एवं साक्षरता विभाग, मानव संसाधन विकास मंत्रालय, भारत
          सरकार द्वारा श्रमिक विद्यापीठ के नाम से सन् 1965 में वरली, मुम्बई से हुई।
          सन् 2000 से इसका नाम श्रमिक विद्यापीठ से जन शिक्षण संस्थान कर दिया गया।
          <br />
          <br />
          &nbsp; &nbsp; जन शिक्षण संस्थान, बीकानेर द्वारा अब तक संचालित विभिन्न
          प्रकार के रोजगार- स्वरोजगार परक पाठ्यक्रमों में मार्च, 2024 तक निर्धारित
          लक्ष्य समूह के 48045 महिला- पुरुषों को विभिन्न कौशल प्रशिक्षणों में
          प्रशिक्षित किया गया है।
        </InfoCard>

        <InfoCard title="मुख्य उद्देश्य:">
          जिले की शहरी कच्ची बस्तियों एवं ग्रामीण क्षेत्रों के निरक्षर, नवसाक्षर,
          अल्पशिक्षित, स्कूली ड्रॉप-आउट, सामाजिक आर्थिक दृष्टि से पिछड़े तथा वंचित
          वर्ग के बेरोजगार महिला-पुरुषों को स्थानीय बाजार की माँग के अनुसार
          व्यावसायिक कौशल प्रशिक्षणों में दक्ष कर उनको सामाजिक एवं आर्थिक रूप से
          स्वावलंबी बनाना और जीवन कौशल शिक्षा के माध्यम से व्यक्तित्व विकास, सामाजिक
          विकास एवं राष्ट्रीय सरोकार की कार्य-गतिविधियों का नियमित संचालन करना।
        </InfoCard>

        <InfoCard title="लक्ष्य समूह:">
          बीकानेर जिले के निरक्षर, नवसाक्षर, अल्पशिक्षित, स्कूली ड्रॉप आउट तथा
          सामाजिक एवं आर्थिक रूप से पिछड़े एवं वंचित वर्ग के 15-45 आयुवर्ग के
          महिला-पुरुष।
        </InfoCard>

        <InfoCard title="निःशुल्क प्रशिक्षण">
          संस्थान द्वारा अनुसूचित जाति एवं अनुसूचित जनजाति (SC/ST) वर्ग, बीपीएल (BPL)
          एवं दिव्यांग श्रेणी के व्यक्तियों को निःशुल्क प्रशिक्षण दिया जाता है।
        </InfoCard>
      </div>
    </div>
  );
};

export default Introduction;
